/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
import { api, registry, me } from './api';
import CacheStorage from './CacheStorage';
import MeRepository from './MeRepository';
import moment from 'moment';
import { entities, NotificationModule } from '../Constants';
const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const year = moment().year() + 2;

const yearsArray = [
  year - 5,
  year - 4,
  year - 3,
  year - 2,
  year - 1,
  year,
  year + 1,
  year + 2,
  year + 3,
];


const getSections = async () => (await api.getAll('/inspection/sections')).data;

const fetchYears = async () => {
  yearsArray.forEach(async (element) => {
    const url = `${baseURL}/inspection/calendar/?page=1&pageSize=10&emailCompiler=&emailDataApprover=&emailDivisionManager=&referenceYear=${element}&plannedWeeks=&monthNumbers=&needToChange=true`;
    await api.getAll(url);
    await api.getAll(`${baseURL}/me/weeks/${element}`);
  });
};

const fetchDivisionWorkSiteProject = async () => {
  const worksites = await MeRepository.getWorkSites();
  for (let i = 0; i < worksites.length; i++) {
    const worksite = worksites[i];
    //  await api.get('inspection/inspectors/', worksite.id);
  }
};
const updateCachedInspection = async (data) => {
  const url = `${baseURL}/inspection/${data.id}`;
  await cacheStorage.updateCache(data, url);
};

const clearOldYear = async (data) => {
  return yearsArray.forEach(async (element) => {
    if (element !== data.referenceYear) {
      const url = `${baseURL}/inspection/calendar/?page=1&pageSize=10&emailCompiler=&emailDataApprover=&emailDivisionManager=&referenceYear=${element}&plannedWeeks=&monthNumbers=&needToChange=true`;
      const items = await cacheStorage.getFromCache(url);

      if (items && items.itemList) {
        const index = items.itemList.findIndex((el) => el.id === data.id);
        items.itemList.splice(index, 1);
        items.rowCount -= 1;
      }
      if (items) await cacheStorage.updateCache(items, url);
    }
  });
};

const updateCachedInspectionList = async (data) => {
  await clearOldYear(data);
  const url = `${baseURL}/inspection/calendar/?page=1&pageSize=10&emailCompiler=&emailDataApprover=&emailDivisionManager=&referenceYear=${data.referenceYear}&plannedWeeks=&monthNumbers=&needToChange=true`;
  const items = await cacheStorage.getFromCache(url);

  if (items && items.itemList) {
    const element = items.itemList.find((el) => el.id === data.id);

    if (!element || element == null) {
      items.itemList = items.itemList.concat([data]);
      items.rowCount += 1;
    } else {
      items.itemList[items.itemList.indexOf(element)] = data;
    }

    await cacheStorage.updateCache(items, url);
  }
};

const updateCachedCarList = async (data) => {
  let url = `${baseURL}/inspection/${data.idInspection}`;
  const inspection = await cacheStorage.getFromCache(url);
  if (inspection) {
    const answer = inspection.inspectionReport.checkList.answers.find(
      (el) => el.id === data.idAnswer
    );
    answer.car = data;

    inspection.inspectionReport.checkList.answers[
      inspection.inspectionReport.checkList.answers.indexOf(answer)
    ] = answer;
    await cacheStorage.updateCache(inspection, url);

    if (!data.inspectionReport) {
      data.inspectionReport = {
        idCompiler: inspection.inspectionReport.idCompiler,
        idApprover: inspection.inspectionReport.idApprover,
        idDivisionManager: inspection.inspectionReport.idDivisionManager,
        idStatus: inspection.inspectionReport.idStatus,
      };
    }
    if (!data.inspection) {
      data.inspection = {
        inspectionCode: inspection.inspectionCode,
      };
    }
  }

  url = `${baseURL}/inspection/${data.idInspection}/car`;
  const items = (await cacheStorage.getFromCache(url)) || { inspectionCAR: [] };

  const element = items.inspectionCAR.find((el) => el.id === data.id);

  if (element == null) {
    items.inspectionCAR = items.inspectionCAR.concat([data]);
  } else {
    items.inspectionCAR[items.inspectionCAR.indexOf(element)] = data;
  }

  await cacheStorage.updateCache(items, url);

  url = `${baseURL}/inspection/${data.idInspection}/answer/${data.idAnswer}/car/${data.id}`;

  await cacheStorage.updateCache(data, url);
};

const getCachedEmployees = async () => {
  const url = `${baseURL}/employees/all`;
  const items = await this.cacheStorage.getFromCache(url);
  return items || undefined;
};

const getEmployees = async () =>
  (await getCachedEmployees()) || (await api.getAll('/employees/all')).data;

const getInspectionType = async () => api.getAll(`${baseURL}/admin/inspectiontype?page=0&parent=`);
const updateInspectionFilter =async (data) => {
  const url = `${baseURL}/inspection/filter`; 
  await cacheStorage.updateCache(data, url);
};
const updateInspectionCalendarFilter =async (data) => {
  const url = `${baseURL}/inspection/filter/calendar`; 
  await cacheStorage.updateCache(data, url);
};
const getBackPaged = async () => {
  const url = `${baseURL}/inspection/filter`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getBackPagedCalendar = async () => {
  const url = `${baseURL}/inspection/filter/calendar`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const InspectionRepository = {
  updateCachedInspection,
  updateCachedInspectionList,
  getEmployees,
  getBackPaged,
  getBackPagedCalendar,
  updateInspectionFilter,
  updateInspectionCalendarFilter,
  updateCachedCarList,
  preFetch: async () => {
    await fetchYears();
    await fetchDivisionWorkSiteProject();
    await getInspectionType();
    await getSections();
  
  },
};
export default InspectionRepository;
